import styled from "styled-components";

export const ReportIssueStyles = styled.div`
  #CTA {
    margin: 40px 0;

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      padding: 30px;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);

      img {
        width: 45%;
        max-width: 500px;

        @media (max-width: 768px) {
          display: none;
        }
      }

      .form {
        width: 50%;

        @media (max-width: 768px) {
          width: 100%;
        }

        h2 {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 25px;
          color: #333;
        }

        form {
          display: flex;
          flex-direction: column;
          gap: 15px;

          .button {
            background: #4a90e2;
            color: white;
            border: none;
            border-radius: 4px;
            padding: 12px 20px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: background 0.3s ease;
            margin-top: 10px;

            &:hover {
              background: #3a80d2;
            }
          }
        }
      }
    }
  }
`;
